import component from './UiMsgBox.vue'
export default component
